import { openDB } from "idb";

const DB_NAME = "pinwanwan_reward_db";
const DB_VERSION = 3;
const STORE_NAME = "reward_entries";

const dbPromise = openDB(DB_NAME, DB_VERSION, {
  upgrade(db, oldVersion, newVersion, transaction) {
    let store;

    if (!db.objectStoreNames.contains(STORE_NAME)) {
      store = db.createObjectStore(STORE_NAME, {
        keyPath: "local_id",
      });
    } else {
      store = transaction.objectStore(STORE_NAME);
    }

    if (!store.indexNames.contains("status")) {
      store.createIndex("status", "status");
    }

    if (!store.indexNames.contains("created_at")) {
      store.createIndex("created_at", "created_at");
    }

    if (!store.indexNames.contains("sync_after")) {
      store.createIndex("sync_after", "sync_after");
    }
  },
});

export async function addQueuedReward({
  phone_number,
  order_amount,
  status = "draft_queued",
  sync_after,
}) {
  const db = await dbPromise;

  const item = {
    local_id: `local_${Date.now()}_${Math.random().toString(36).slice(2)}`,
    phone_number,
    order_amount,
    points: null,
    status,
    server_id: null,
    message: "You can remove this entry before it syncs.",
    created_at: new Date().toISOString(),
    sync_after,
    synced_at: null,
    cancelled_at: null,
  };

  await db.add(STORE_NAME, item);
  return item;
}

export async function getRewardEntries() {
  const db = await dbPromise;
  const items = await db.getAll(STORE_NAME);

  return items.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
}

export async function getSyncableRewards(limit = 20) {
  const db = await dbPromise;
  const items = await db.getAll(STORE_NAME);
  const now = new Date();

  return items
    .filter((item) => {
      if (item.status === "queued") return true;

      if (item.status === "draft_queued") {
        return item.sync_after && new Date(item.sync_after) <= now;
      }

      return false;
    })
    .sort((a, b) => new Date(a.created_at) - new Date(b.created_at))
    .slice(0, limit);
}

export async function updateRewardEntry(localId, updates) {
  const db = await dbPromise;
  const item = await db.get(STORE_NAME, localId);

  if (!item) return null;

  const updatedItem = {
    ...item,
    ...updates,
  };

  await db.put(STORE_NAME, updatedItem);
  return updatedItem;
}

export async function cancelRewardEntry(localId) {
  return updateRewardEntry(localId, {
    status: "cancelled",
    message: "Entry removed before sync.",
    cancelled_at: new Date().toISOString(),
  });
}

export async function clearAllRewardEntries() {
  const db = await dbPromise;
  await db.clear(STORE_NAME);
}